import React, { useEffect } from 'react';
import { AdvancedMarker, Map, useMap } from '@vis.gl/react-google-maps';
import { NumberedPin } from './NumberedPin';

const DEFAULT_CENTER = { lat: 51.5074, lng: -0.1278 };
const DEFAULT_ZOOM = 10;
const MAP_ID = '882c002e2618ec772825174f';

const FitBounds = ({ products }) => {
  const map = useMap();

  useEffect(() => {
    if (!map || !products?.length || !window.google?.maps) return;

    if (products.length === 1) {
      map.setCenter(products[0].coordinates);
      map.setZoom(13);
      return;
    }

    const bounds = new window.google.maps.LatLngBounds();
    products.forEach((p) =>
      bounds.extend(
        new window.google.maps.LatLng(p.coordinates.lat, p.coordinates.lng),
      ),
    );
    map.fitBounds(bounds, 80);
  }, [map, products]);

  return null;
};

export const ProductMap = ({ products }) => (
  <Map
    mapId={MAP_ID}
    defaultCenter={DEFAULT_CENTER}
    defaultZoom={DEFAULT_ZOOM}
    gestureHandling="auto"
    disableDefaultUI
    className="h-full w-full"
  >
    <FitBounds products={products} />
    {products.map((product, i) => (
      <AdvancedMarker
        key={product.id}
        position={product.coordinates}
        clickable={false}
      >
        <NumberedPin index={i + 1} />
      </AdvancedMarker>
    ))}
  </Map>
);
